import { TokenWithValue } from '@/domain/common/types'
import { TokenIcon } from '@/ui/atoms/token-icon/TokenIcon'
import { Typography } from '@/ui/atoms/typography/Typography'

import { SuccessViewCheckmark } from '../components/success-view/SuccessViewCheckmark'
import { SuccessViewContent } from '../components/success-view/SuccessViewContent'
import { SuccessViewProceedButton } from '../components/success-view/SuccessViewProceedButton'
import { SuccessViewSummaryPanel } from '../components/success-view/SuccessViewSummaryPanel'
import { objectiveTypeToVerb, SuccessViewObjectiveType } from '../logic/title'
import { getDisplayToken } from '@/domain/hooks/useDisplayToken'
import { useChainId } from 'wagmi'

export interface SuccessViewProps {
  objectiveType: SuccessViewObjectiveType
  tokenWithValue: TokenWithValue
  onProceed: () => void
  proceedText: string
  isModal?: boolean
  className?: string
}
export function SuccessView({
  objectiveType,
  tokenWithValue,
  onProceed,
  proceedText,
  isModal,
  className,
}: SuccessViewProps) {
  const { token, value } = tokenWithValue
  const chainId = useChainId()
  const displayToken = getDisplayToken(chainId, token)

  return (
    <SuccessViewContent className={className}>
      <SuccessViewCheckmark isModal={isModal} />
      <SuccessViewSummaryPanel title={objectiveTypeToVerb[objectiveType]}>
        <div className="flex items-center gap-2">
          <TokenIcon token={token} className="h-6" />
          <span className="font-semibold">{displayToken.symbol}</span>
        </div>
        <div className="flex grow flex-col">
          <Typography className="text-right font-primary">{token.format(value, { style: 'auto' })}</Typography>
          <Typography variant="prompt" className="text-right">
            {token.formatUSD(value)}
          </Typography>
        </div>
      </SuccessViewSummaryPanel>
      <SuccessViewProceedButton onProceed={onProceed}>{proceedText}</SuccessViewProceedButton>
    </SuccessViewContent>
  )
}
